import axios from "axios";

const envBase = process.env.REACT_APP_BACKEND_URL;
const base = (envBase && envBase !== 'undefined' ? envBase : '').replace(/\/$/, '');
const resolvedBase = base || (typeof window !== 'undefined' ? window.location.origin : '');

const api = axios.create({
  baseURL: `${resolvedBase}/api`,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const t = localStorage.getItem('jwt_fallback');
  if (t) config.headers['Authorization'] = `Bearer ${t}`;
  return config;
});

export default api;
